import { Component, OnInit } from '@angular/core';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-update-about',
    templateUrl: './update-about.component.html',
    styleUrls: ['./update-about.component.scss'],
})
export class UpdateAboutComponent implements OnInit {
    subscriptions: Subscription = new Subscription();
    public ecosystem: string = this.profileService.getCurrentEcosystem();
    public tx_biography: string;

    constructor(private profileService: ProfileService, private matSnackBar: MatSnackBar, private dialogRef: MatDialogRef<UpdateAboutComponent>) {}

    ngOnInit(): void {
        this.tx_biography = this.profileService.tx_biography;
        this.subscriptions.add(
            this.profileService.resetDataSubject.pipe(filter((x) => x.loadData)).subscribe(() => {
                this.tx_biography = this.profileService.tx_biography;
            })
        );
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    saveBiography() {
        const data = {
            artist: 0,
            biography: this.tx_biography,
        };
        firstValueFrom(this.profileService.patchOneUrl(data, this.ecosystem, `/${this.profileService.getEcosystemRoute(this.ecosystem)}/0`)).then(() => {
            Swal.fire({
                title: 'Confirmación',
                text: 'Guardado correctamente',
                icon: 'success',
                confirmButtonColor: '#28a745',
                confirmButtonText: 'Aceptar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.profileService.tx_biography = this.tx_biography
                    this.dialogRef.close(this.tx_biography);
                }
            });
        });
    }

    closeModal() {
        this.dialogRef.close();
    }
}
